export default "__VITE_ASSET__96dd71b7__"